import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import SiderTopic from '../../../components/siderTopic';
import NewsSiderContent from '../../../components/newsSiderContent';
import NewsSiderTabs from '../../../components/newsSiderTabs';

class HYNewsSider extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { hgNewsSiderTitle, hgNewsSiderContent, hgNewsSiderTabs },
        } = this.props;

        return (
            <div id="wutonghuiSiderList" className={styles.sider_box}>
                <div className={styles.sider}>
                    <Chip
                        id="50069"
                        type="struct"
                        title="财经梧桐汇标题"
                        groupName="军事历史要闻区左侧栏"
                        content={hgNewsSiderTitle}>
                        <SiderTopic />
                    </Chip>
                    <Chip
                        id="75070"
                        type="recommend"
                        title="财经列表"
                        groupName="军事历史要闻区左侧栏"
                        content={hgNewsSiderContent}
                        translate="handleNewsSiderContentData"
                        translateOptions={{ index: 0 }}>
                        <NewsSiderContent hasTopic />
                    </Chip>
                </div>
                <Chip
                    id="50099"
                    type="struct"
                    title="娱乐标签"
                    groupName="军事历史要闻区左侧栏"
                    content={hgNewsSiderTabs}>
                    <NewsSiderTabs />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(HYNewsSider);
